<template>
  <div class="comp-dashboard-group-field">
    <jw-modal class="dashboard-modal" popup-container=".comp-dashboard-group-field" :visible="visible" :title="$t('看板视图')" title-align="start" :closable="false" @cancel="closeModal" @ok="handleOk">
      <div class="field-tips">{{ $t('选择一个字段作为“分组”，数据将按照此字段中的字段值分组显示在看板中。仅支持单选、下拉单选和人员类型字段。') }}</div>
      <div class="radio-title">{{ $t('选择分组字段') }}</div>
      <jw-spin :loading="isLoading" style="width: 100%">
        <jw-input :placeholder="$t('搜索字段名称')" v-model="searchText">
          <template #suffix>
            <qfei-icon-search-two-outlined />
          </template>
        </jw-input>
        <template v-if="getGroupFields()">
          <jw-radio-group v-model="groupField" direction="vertical" class="radio-group-box">
            <jw-radio v-for="gf in groupFields?.filter((v) => searchText == '' || v?.fieldName?.indexOf(searchText) > -1)" :key="gf?.fieldKey" :value="gf?.fieldKey">
              <component :is="fieldIconMapping[gf?.fieldType]" />
              {{ gf?.fieldName }}
            </jw-radio>
          </jw-radio-group>
        </template>
        <template v-else>
          <div class="no-data-svg">
            <jw-empty :img-src="noDataSvg" :description="t('暂无分组字段')"></jw-empty>
          </div>
        </template>
        <div v-if="isError && !groupField" class="error-text">{{ $t('请选择分组字段') }}</div>
      </jw-spin>
    </jw-modal>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import useViewFields from '@/hooks/view-fields';
import { setService } from '@/api';
import useFields from '@/hooks/fields';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import noDataSvg from '@/assets/images/no-data-150.svg';
const { t } = useI18n();
const { getDashBoardGroupFields } = useViewFields();
const { fieldIconMapping } = useFields();
const emits = defineEmits(['cb']);
const groupFields = ref([]);
const groupField = ref('');
const visible = ref(false);
const isLoading = ref(false);
const searchText = ref('');
const isError = ref(false);
const open = async (entity, _groupField = null) => {
  searchText.value = '';
  groupFields.value = [];
  groupField.value = _groupField || '';
  visible.value = true;
  await getEnableField(entity);
  // 判断groupField 是否有值
  if (!groupField.value) groupField.value = groupFields.value?.[0]?.fieldKey || '';
};
const closeModal = () => {
  visible.value = false;
};
const handleOk = () => {
  if (!groupField.value) {
    isError.value = true;
    return;
  }
  emits('cb', {
    groupField: groupField.value,
    fieldInfo: groupFields.value?.find((gf) => gf?.fieldKey == groupField.value)
  });
  closeModal();
};
const getEnableField = async (entity) => {
  try {
    const params = {
      entity: entity
    };
    isLoading.value = true;
    const res = await setService.getFormDesignFields(params);
    isLoading.value = false;
    if (!res?.error) {
      groupFields.value = getDashBoardGroupFields(res.result);
    } else {
      Message.error(res?.error?.msg || t('获取数据失败'));
    }
  } catch (e) {
    console.log(e);
    isLoading.value = false;
  }
};

const getGroupFields = () => {
  if (searchText.value) {
    const _array = groupFields.value?.filter((v) => v?.fieldName?.indexOf(searchText.value) > -1) || [];
    return _array?.length > 0;
  }
  return true;
};

defineExpose({ open });
</script>
<style scoped lang="less">
@import './dashboard-group-field.less';
</style>
